import React from "react";
import GatsbyConfig from "../../../gatsby-config.js";
import { getParamFromQueryString } from "../../utils/app-helpers";
import Link from "gatsby-link";
import BookmarkScroll from "./bookmark-scroll";

const { siteMetadata: config } = GatsbyConfig;

export default class RoomCardBlank extends React.Component {
  render() {
    if (typeof window === "undefined") return <div />;
    const { trip } = this.props;
    const {
      slug,
      rooms,
      roomUpgradeLabel = "Upgrade to a Suite",
    } = config.trips[trip];
    const promo = window.location.href.match(/\/onlocation/i)
      ? "onlocation"
      : getParamFromQueryString("promo", window.location.href);
    let suiteImage = "";
    const linkTo =
      promo === "onlocation"
        ? `/${slug}/onlocation/?tab=suites`
        : `/${slug}/prices/?tab=suites${promo ? `&promo=${promo}` : ""}`;

    for (const key in rooms) {
      const room = rooms[key];

      if (room.hideFromBooking) continue;
      if (room.kind === "suite" || room.kind === "hybrid") {
        suiteImage = room.image;
      }
    }
    return (
      <div className="card room blank highlighted">
        <div
          className="image all-100x40"
          style={{ backgroundImage: 'url("' + suiteImage + '")' }}
        />
        <div className="body">
          <div>
            <h2>{roomUpgradeLabel}</h2>
          </div>
        </div>
        <BookmarkScroll bookmark="content">
          <Link className="btn" to={linkTo}>
            View Suites <i className="fa fa-angle-right" />
          </Link>
        </BookmarkScroll>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/partials/room-card-blank.js